import { ArticleEntity, BlogPostEntity } from 'mk2/apps/blogs/schemas';
import * as blogsUrls from 'mk2/apps/blogs/urls';
import { url } from 'mk2/helpers/urls';
import { PhotoEntity } from 'mk2/schemas';

export const getModelAndId = (key: string): string[] => key.split('/');

export function articleUrl(article: ArticleEntity): string {
    return article.isMagazine
        ? url(blogsUrls.blogsMagazineArticle, {articleSlug: article.slug})
        : url(blogsUrls.blogsArticle, {username: article.user.username, articleSlug: article.slug});
}

export function largestAvailablePhotoVersionOfBlogPost(photo: PhotoEntity, wishedVersion: 's720x720' | 's1600x1600') {
    return wishedVersion === 's1600x1600' ? 's1600x1600' : 's720x720';
}

export const canBeSetSticky = (post: BlogPostEntity): boolean => {
    return !!post.perex;
};
